﻿import { useCallback } from 'react';
import Coordinate from '../../../../common/coordinate';
import { LocationApiService } from '../../../../services/axios/axios-api-generated';
import { CityLocationDetails } from './use-flight-position';

export function useNearestCity() {
    const getNearestCity = useCallback(async (position: Coordinate): Promise<CityLocationDetails | null> => {
        if (!position.isValid) {
            return null;
        }

        const nearestCityResponse =
            (await LocationApiService.getNearestCity(
                {
                    body: {
                        lat: position.lat,
                        lon: position.lng
                    }
                },
                { withAuthorization: true }
            )) ?? undefined;
        if (nearestCityResponse && nearestCityResponse.nearestCity) {
            return {
                name: nearestCityResponse.nearestCity,
                distance: nearestCityResponse.distanceFromCity ?? null,
                fromBearing: nearestCityResponse.bearingFromCity ?? null
            };
        }

        return null;
    }, []);

    return { getNearestCity };
}
